import { ERROR_TEXTS } from "../utils/constants";
import { apiSaveStep, API_STEPS } from "../api/apiSaveStep";
import { apiGenerateOtp } from "../api/apiGenerateOtp";

export const CONSENT_FORM_FIELD_NAMES = {
    isFastSwitch: 'passaggioRapido',
    acceptAll: 'acceptAll',

    acceptContract: 'accettazioneContratto',
    acceptLegal: 'noteLegali',
    acceptSwitch: 'recessoFornitore',
    acceptPrivacy: 'informativaPrivacy',

    acceptContractError: 'acceptContractError',
    acceptLegalError: 'acceptLegalError',
    acceptSwitchError: 'acceptSwitchError',
    acceptPrivacyError: 'acceptPrivacyError',

    clausoleVessatorie: 'clausoleVessatorie',
    freeMarketOffer: 'offertaMercatoLibero',

    clausoleVessatorieError: 'clausoleVessatorieError',
    freeMarketOfferError: 'offertaMercatoLiberoError',
    marketingMailAcceptedError: 'marketingMailError',
    marketingEmailAcceptedError: 'marketingEmailError',
    marketingPhoneAcceptedError: 'marketingPhoneError',

    marketingMailAccepted: 'marketingPosta',
    marketingMailNotAccepted: 'marketingPostaNo',
    marketingPhoneAccepted: 'marketingTelefono',
    marketingPhoneNotAccepted : 'marketingTelefonoNo',
    marketingEmailAccepted: 'marketingEmail',
    marketingEmailNotAccepted: 'marketingEmailNo',
    marketingDataAccepted: 'marketingElaborazione',
    marketingDataNotAccepted: 'marketingElaborazioneNo',
    marketingDataAcceptedError: 'marketingElaborazioneError',

    timeSpent: "tempoImpiegato",
    timeStart: "timeStart",
    isSubmittingForm: 'isSubmittingForm',
    errorFormSubmission: 'errorFormSubmission',
    successText: 'successText'
}

const defaultErrorState = {
    [CONSENT_FORM_FIELD_NAMES.acceptLegalError]: '',
    [CONSENT_FORM_FIELD_NAMES.acceptContractError]: '',
    [CONSENT_FORM_FIELD_NAMES.acceptSwitchError]: '',
    [CONSENT_FORM_FIELD_NAMES.acceptPrivacyError]: '',
    [CONSENT_FORM_FIELD_NAMES.clausoleVessatorieError]: '',
    [CONSENT_FORM_FIELD_NAMES.freeMarketOfferError]: '',
    [CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError]: '',
    [CONSENT_FORM_FIELD_NAMES.marketingEmailAcceptedError]: '',
    [CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError]: '',
    [CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError]: '',

    [CONSENT_FORM_FIELD_NAMES.errorFormSubmission]: '',
    [CONSENT_FORM_FIELD_NAMES.successText]: ''
}

const initialState = {
    [CONSENT_FORM_FIELD_NAMES.isFastSwitch]: false,
    [CONSENT_FORM_FIELD_NAMES.acceptAll]: false,
    [CONSENT_FORM_FIELD_NAMES.acceptContract]: false,
    [CONSENT_FORM_FIELD_NAMES.acceptLegal]: false,
    [CONSENT_FORM_FIELD_NAMES.acceptSwitch]: false,
    [CONSENT_FORM_FIELD_NAMES.acceptPrivacy]: false,

    [CONSENT_FORM_FIELD_NAMES.clausoleVessatorie]: false,
    [CONSENT_FORM_FIELD_NAMES.freeMarketOffer]: false,

    [CONSENT_FORM_FIELD_NAMES.marketingMailAccepted]: false,
    [CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted]: false,
    [CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted]: false,
    [CONSENT_FORM_FIELD_NAMES.marketingDataAccepted]: false,

    [CONSENT_FORM_FIELD_NAMES.timeSpent]: 0,
    [CONSENT_FORM_FIELD_NAMES.timeStart]: null,
    [CONSENT_FORM_FIELD_NAMES.isSubmittingForm]: false,

    ...defaultErrorState
}

export const CONSENT_FORM_CHANGE_FIELD = 'CONSENT_FORM_CHANGE_FIELD';
export const onChangeConsentForm = (name, value) => {
    return { type: CONSENT_FORM_CHANGE_FIELD, name, value }
}

const CONSENT_FORM_SET_ERROR = 'CONSENT_FORM_SET_ERROR';
const consentFormSetError = (name, value) => {
    return { type: CONSENT_FORM_SET_ERROR, name, value }
}

const CONSENT_FORM_RESET_ERROR = 'CONSENT_FORM_RESET_ERROR';
const consentFormResetError = (name) => {
    return { type: CONSENT_FORM_RESET_ERROR, name }
}

export function consentFormValidateAndSubmit(finished = true) {
    return async (dispatch, getState) => {
        const { consentFormReducer, globalFormFieldsReducer } = getState();
        const form = { ...consentFormReducer };
        const otp = globalFormFieldsReducer.otp;

        dispatch(consentFormResetError());

        const timeSpent = form[CONSENT_FORM_FIELD_NAMES.timeSpent]
            + parseInt(Date.now() / 1000, 10) - form[CONSENT_FORM_FIELD_NAMES.timeStart];

        form[CONSENT_FORM_FIELD_NAMES.timeSpent] = timeSpent;
        dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.timeSpent, timeSpent));
        dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)));

        if (!finished) {
            dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.isSubmittingForm, true));
            try {
                await apiSaveStep(API_STEPS.fourth, { ...form, otp, finished: false });
                await apiGenerateOtp(otp);
                return dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.successText, ERROR_TEXTS.saveSuccess));
            } catch (error) {
                dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.serverError));
                throw "Error saving data";
            } finally {
                dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.isSubmittingForm, false));
            }
        }

        let error = false;
        if (!form[CONSENT_FORM_FIELD_NAMES.acceptContract]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.acceptContractError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        if (!form[CONSENT_FORM_FIELD_NAMES.acceptLegal]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.acceptLegalError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        if (!form[CONSENT_FORM_FIELD_NAMES.acceptPrivacy]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.acceptPrivacyError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        if (!form[CONSENT_FORM_FIELD_NAMES.acceptSwitch]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.acceptSwitchError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        if (!form[CONSENT_FORM_FIELD_NAMES.clausoleVessatorie]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.clausoleVessatorieError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        if (!form[CONSENT_FORM_FIELD_NAMES.freeMarketOffer]) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.freeMarketOfferError, ERROR_TEXTS.contractAccept))
            error = true;
        }
        //phone consent
        if (!form[CONSENT_FORM_FIELD_NAMES.marketingPhoneAccepted] && !form[CONSENT_FORM_FIELD_NAMES.marketingPhoneNotAccepted] ) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.marketingPhoneAcceptedError, ERROR_TEXTS.consentAccept))
            error = true;
        }
        // mail consent
        if (!form[CONSENT_FORM_FIELD_NAMES.marketingMailAccepted] && !form[CONSENT_FORM_FIELD_NAMES.marketingMailNotAccepted] ) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.marketingMailAcceptedError, ERROR_TEXTS.consentAccept))
            error = true;
        }
        // email consent
        if (!form[CONSENT_FORM_FIELD_NAMES.marketingEmailAccepted] && !form[CONSENT_FORM_FIELD_NAMES.marketingEmailNotAccepted] ) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.marketingEmailAcceptedError, ERROR_TEXTS.consentAccept))
            error = true;
        }
        //data consent
        if (!form[CONSENT_FORM_FIELD_NAMES.marketingDataAccepted] && !form[CONSENT_FORM_FIELD_NAMES.marketingDataNotAccepted] ) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.marketingDataAcceptedError, ERROR_TEXTS.consentAccept))
            error = true;
        }
        // Check if the contract has been accepted
        if (error) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.contractAccept));
            throw "Missing accept";
        }

        dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.isSubmittingForm, true));
        try {
            await apiSaveStep(API_STEPS.fourth, { ...form, otp, finished: true });
        } catch (error) {
            dispatch(consentFormSetError(CONSENT_FORM_FIELD_NAMES.errorFormSubmission, ERROR_TEXTS.serverError));
            throw "Error saving data";
        } finally {
            dispatch(onChangeConsentForm(CONSENT_FORM_FIELD_NAMES.isSubmittingForm, false));
        }
    }
}

const CONSENT_FORM_SET_FROM_MODEL = 'CONSENT_FORM_SET_FROM_MODEL';
export const consentFormSetFromModel = state => {
    return { type: CONSENT_FORM_SET_FROM_MODEL, state: state.fourthStep }
}

export function consentFormReducer(state = initialState, action) {
    switch (action.type) {
        case CONSENT_FORM_CHANGE_FIELD: {
            if (action.name === CONSENT_FORM_FIELD_NAMES.acceptAll) {
                return {
                    ...state,
                    [action.name]: action.value,
                    [CONSENT_FORM_FIELD_NAMES.acceptContract]: action.value,
                    [CONSENT_FORM_FIELD_NAMES.acceptLegal]: action.value,
                    [CONSENT_FORM_FIELD_NAMES.acceptSwitch]: action.value,
                    [CONSENT_FORM_FIELD_NAMES.acceptPrivacy]: action.value,
                }
            } else if (
                action.name === CONSENT_FORM_FIELD_NAMES.acceptContract 
                || action.name === CONSENT_FORM_FIELD_NAMES.acceptLegal
                || action.name === CONSENT_FORM_FIELD_NAMES.acceptSwitch
                || action.name === CONSENT_FORM_FIELD_NAMES.acceptPrivacy
            ) {
                const contract = CONSENT_FORM_FIELD_NAMES.acceptContract;
                const legal = CONSENT_FORM_FIELD_NAMES.acceptLegal;
                const acceptSwitch = CONSENT_FORM_FIELD_NAMES.acceptSwitch;
                const privacy = CONSENT_FORM_FIELD_NAMES.acceptPrivacy;
                let acceptAll = false;

                let currentContractValue = state[contract];
                let currentLegalValue = state[legal];
                let currentSwitchValue = state[acceptSwitch];
                let currentPrivacyValue = state[privacy];

                if (action.name === contract || action.name === legal || action.name === acceptSwitch || action.name === privacy) {
                    if (action.name === contract) currentContractValue = action.value;
                    if (action.name === legal) currentLegalValue = action.value;
                    if (action.name === acceptSwitch) currentSwitchValue = action.value;
                    if (action.name === privacy) currentPrivacyValue = action.value;

                    acceptAll = currentContractValue && currentLegalValue && currentSwitchValue && currentPrivacyValue;
                }

                return { 
                    ...state, 
                    [action.name]: action.value, 
                    [CONSENT_FORM_FIELD_NAMES.acceptAll]: acceptAll
                }
            }
            return { ...state, [action.name]: action.value }
        }
        case CONSENT_FORM_SET_ERROR: {
            return { ...state, [action.name]: action.value }
        }
        case CONSENT_FORM_RESET_ERROR: {
            if (!action.name) {
                return { ...state, ...defaultErrorState }
            } else {
                return { ...state, [action.name]: '' }
            }
        }
        case CONSENT_FORM_SET_FROM_MODEL: {
            return { ...state, ...action.state }
        }
        default: {
            return state;
        }
    }
}